import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=150ae5c2&scoped=true&"
import script from "./Chatbot.vue?vue&type=script&lang=js&"
export * from "./Chatbot.vue?vue&type=script&lang=js&"
import style0 from "./Chatbot.vue?vue&type=style&index=0&id=150ae5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ae5c2",
  null
  
)

export default component.exports